import DefaultLayout from "../layout/Default";
export const WaitVerification = () => {
  return (
    <DefaultLayout svg="code">
      <div className="p-3 m-3" style={{ maxWidth: 350 }}>
        <h1 className="text-darkblue fw-bold text-left">
          Waiting for verification
        </h1>
        <div style={{ minWidth: 280 }}>
          Your account will be ready as soon as the backoffice will verify your
          identity. This process may take a really long time.
        </div>
      </div>
    </DefaultLayout>
  );
};

export default WaitVerification;
